export enum NotificationAnimationType {
  Fade = 'fade',
  FromTop = 'fromTop',
  FromRight = 'fromRight',
  FromBottom = 'fromBottom',
  FromLeft = 'fromLeft',
  Scale = 'scale',
  Rotate = 'rotate'
}
